import { createClient } from '@supabase/supabase-js';

// Proxy preko iste domene (/supabase) zaobilazi SSL problem na Kong domeni.
// Override s VITE_SUPABASE_URL ako postaviš vlastitu domenu s valjanim certifikatom.
const supabaseUrl =
  import.meta.env.VITE_SUPABASE_URL || `${window.location.origin}/supabase`;
const supabaseKey = 'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJpc3MiOiJzdXBhYmFzZSIsImlhdCI6MTc0MjM4MzUwMCwiZXhwIjo0ODk4MDU3MTAwLCJyb2xlIjoiYW5vbiJ9.RYWEgPZ8qtoyXNwly-9JaKIkAG7FJCCgYkb6e-N7aVM';

export const supabase = createClient(supabaseUrl, supabaseKey);

// Types for our database tables
export interface Registration {
  id?: string;
  first_name: string;
  last_name: string;
  institution: string;
  profession: 'nurse' | 'doctor' | 'pharmacy' | 'other';
  license_type?: string;
  license_number?: string;
  email: string;
  phone: string;
  payment_type: 'personal' | 'institution' | 'sponsor';
  sponsor_name?: string;
  needs_accommodation: boolean;
  accommodation_dates?: string[];
  room_type?: 'single' | 'double';
  roommate_name?: string;
  needs_transport: boolean;
  created_at?: string;
  updated_at?: string;
}

export interface Abstract {
  id?: string;
  title: string;
  authors: string[];
  corresponding_author: string;
  email: string;
  phone: string;
  institution: string;
  abstract_type: 'oral' | 'poster';
  content: string;
  keywords?: string;
  created_at?: string;
  updated_at?: string;
  coauthors?: any;
  document_url?: string;
}

export interface Presentation {
  id?: string;
  title: string;
  authors: string[];
  corresponding_author: string;
  email: string;
  phone: string;
  institution: string;
  presentation_type: 'presentation' | 'eposter';
  file_url: string;
  file_name: string;
  file_size: number;
  created_at?: string;
  updated_at?: string;
} 

export interface ELearningUser {
  id?: string;
  first_name: string;
  last_name: string;
  hkms_hlk_number: string;
  email: string;
  institution: string;
  created_at?: string;
}

export interface ELearningAccessLog {
  id?: string;
  email: string;
  first_name: string;
  last_name: string;
  hkms_hlk_number: string;
  institution: string;
  accessed_at?: string;
  user_agent?: string;
  ip_address?: string;
} 